module.exports = __webpack_public_path__ + "static/The Sceens - Perspective PSD Mockup - by Tranmautritam4-ade354fc537b145b7e5e972028ad3799.png";